export default {"src":"https://static.eleduck.com/_next/static/media/male.adf4d52b.svg","height":26,"width":11,"blurWidth":0,"blurHeight":0};